import { get, getPaged, post } from '../fetch-api';
import { context } from '../auth';

let baseUrl = 'auth';

// prettier-ignore
export const NBXAuth = {
  init: config => ({ baseUrl } = config),

  getSessions: (nextPageUrl) => context.user()
    .then(user => getPaged(nextPageUrl ?? `${baseUrl}/sessions`, user)),

  invalidateAllSessions: () => context.user()
    .then(session => post(`${baseUrl}/invalidate_all_sessions`, {}, session)),

  lockAccount: date => context.user()
    .then(user => post(`${baseUrl}/lock`, { json: { end: date } }, user)),

  twoFactorStatus: () => context.user()
    .then(user => get(`${baseUrl}/totp`, user)),

  twoFactorSetup: code => context.user()
    .then(user => post(`${baseUrl}/totp`, { json: { code } }, user)),

  twoFactorVerify: code => context.user()
    .then(user => post(`${baseUrl}/totp`, { json: { code } }, user)),

  twoFactorDisable: (code, useRecoveryCode) => context.user()
    .then(user => {
      const json = useRecoveryCode ? {
        recovery_code: code
      } : {
        code
      };
      return post(`${baseUrl}/totp/delete`, { json }, user);
    }),

  verify: (token, code, useRecoveryCode = false, isPolling = false) => {
    const json = useRecoveryCode ? {
      token,
      recovery_code: code,
      is_polling: isPolling
    }  : {
      token,
      code,
      is_polling: isPolling
    };
    return post(`${baseUrl}/verify`, {
      json
    })
    .then(session => {
      if (
        session.constructor !== Object
        || Object.entries(session).length === 0
        || session.token === undefined
        || session.userId === undefined
        || session.accountId === undefined
      ) throw 'no_session_found';
      return session;
    });
  }
};
